import { NgModule } from "@angular/core";
import { VersionComponent } from "./version.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import packageJson from "../../../../../package.json";
import { TranslateModule } from "@ngx-translate/core";
import { APP_VERSION } from "./version.token";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [
    VersionComponent
  ],
  providers: [
    { provide: APP_VERSION, useValue: packageJson.version }
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    TranslateModule.forChild()
  ],
  exports: [
    VersionComponent
  ]
})
export class VersionModule {}